import { render, staticRenderFns } from "./MaternityExam.vue?vue&type=template&id=19602446"
import script from "./MaternityExam.vue?vue&type=script&lang=js"
export * from "./MaternityExam.vue?vue&type=script&lang=js"
import style0 from "./MaternityExam.vue?vue&type=style&index=0&id=19602446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports